import styled, {keyframes, css} from "styled-components";

interface WOFColorsBoxProps {
    showSpin: boolean;
}

const rotateBackward = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(-180deg);
  }
`;

const rotateStarting = keyframes`
  from {
    transform: rotate(-180deg);
  }

  to {
    transform: rotate(0deg);
  }
`;

const rotateFullRotation = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const rotateFinish = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(2880deg);
  }
`;


const WOFColorsBox = styled.div<WOFColorsBoxProps>`
    position: relative;
    top: 5px;
    background: url(${({theme}) => theme.images.wheelOfFortune.colors.toString()}) no-repeat center;
    background-size: cover;

    animation-delay: 5s, 7s, 7.25s, 7.25s, 8.45s;
    animation-duration: 2s, 0.25s, 0.25s, 7s;
    animation-iteration-count: 1, 1, 4, 1, 1;
    animation-timing-function: ease, ease-in, linear, cubic-bezier(0, 0, 0.35, 1.16);
    animation-fill-mode: forwards, forwards, forwards, forwards, forwards;

    ${({showSpin}) => showSpin && css`
        animation-name: ${rotateBackward}, ${rotateStarting}, ${rotateFullRotation}, ${rotateFinish};
    `}
    

    z-index: -1;
    height: 100%;
    width: 100%;
`;

export default WOFColorsBox;